export const SENTRY_DSN = 'https://30165019af914a50944a28f086104185@front-monitor.xiaopeng.com/3'
/**
 * 页面常量定义
 */

// 高德地图 Key
export const AMAP_KEY = '7426ea23417565957fa0836a4836a487'
// 高德地图版本号
export const AMAP_VERSION = '2.0' // 1.4.15
export const AMAP_UI_VERSION = '1.0'

// 高德地图插件
export const AMAP_PLUGINS: string[] = [
  'AMap.ControlBar',
  'AMap.Geolocation'
]

export const AMAP_SCRIPT_CALLBACK_NAME = '__amap_init_callback'

export const AMAP_MAIN_SCRIPT_URL =
  `//webapi.amap.com/maps?v=2.0&key=${AMAP_KEY}&callback=${AMAP_SCRIPT_CALLBACK_NAME}&plugin=${AMAP_PLUGINS.join(',')}`

export const AMAP_UI_SCRIPT_URL =
  `//webapi.amap.com/ui/${AMAP_UI_VERSION}/main-async.js`

export const AMAP_SERVICE_HOST = 'http://service.test.xiaopeng.local/insurance/case/webcase'
